export default function AuroraBg({ className = "" }) {
  return (
    <div className={`aurora-bg ${className}`} aria-hidden="true">
      <div className="aurora-blob bg-peach/60" style={{ width: 520, height: 520, top: "-10%", left: "-8%", animationDelay: "0s" }} />
      <div className="aurora-blob bg-lavender/70" style={{ width: 460, height: 460, top: "20%", right: "-10%", animationDelay: "-6s" }} />
      <div className="aurora-blob bg-sage/40" style={{ width: 380, height: 380, bottom: "-12%", left: "30%", animationDelay: "-12s" }} />
      <div className="aurora-blob bg-amber/30" style={{ width: 300, height: 300, bottom: "10%", right: "20%", animationDelay: "-9s" }} />
    </div>
  );
}
